import React from 'react'
import { useParams } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import ResearchDesignTab from './components/ResearchDesignTab';
import ParticipantManagementTab from './components/ParticipantManagementTab';
import DetailHeader from './components/DetailHeader';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useGlobalContext } from '../../Contexts/GlobalContext';
import { getSingleQualitativeProject } from './qualSurveysActions';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';


const UnknownPage = ({ id }) => {
    // navigate(`/surveys/${id}/details`);
    window.location.href = `${window.location.origin}/qualitative-surveys/${id}/research-design`;
    return <h1>Page Not Found</h1>;
};

const QualSurveyDetails = () => {
    const { user } = useGlobalContext()
    const organizationID = user?.organization?._id;

    const { type, id } = useParams();
    const {
        data: projectDetails,
        isLoading: ProjectDetailsLoading,
        error: projectDetailsError } = useQuery(
            {
                queryKey: ['projectDetails', organizationID, id],
                queryFn: () => getSingleQualitativeProject(organizationID, id),
                staleTime: 10000,
                cacheTime: 15000,
            }
        );
    // console.log({ projectDetails, ProjectDetailsLoading, projectDetailsError })

    if (ProjectDetailsLoading) {
        return <div className='flex items-center justify-center h-[85vh]'>
            <Loader useDots={true} />
        </div>
    };
    if (projectDetailsError) {
        return <div className='flex items-center justify-center h-[85vh]'>
            <NoData msg={"Something went wrong while fetching the project details !"} />
        </div>
    }
    const renderComponent = () => {
        switch (type) {
            case "research-design":
                return (
                    <ResearchDesignTab data={projectDetails} />
                );
            case "participant-management":
                return (
                    <ParticipantManagementTab data={projectDetails} />
                );
            default:
                return <UnknownPage id={id} />;
        }
    }
    return (
        <Sidebar>
            <div>
                <DetailHeader data={projectDetails} />
                {renderComponent()}
            </div>
        </Sidebar>
    )
}

export default QualSurveyDetails